import { api } from '@/app/lib/axios';
import { Client, CreateClientPayload, UpdateClientPayload } from '@/app/network/models/client';
import { Contact, CreateContactPayload, UpdateContactPayload } from '@/app/network/models/contact';
import { CreateProjectPayload, Project, UpdateProjectPayload } from '@/app/network/models/project';
import { CodeBasedRef } from '@/app/network/models/refs';

export async function getClients(): Promise<Client[]> {
  return await api.get('clients');
}

export async function getClient({ clientId }: { clientId: number }): Promise<Client> {
  return await api.get(`clients/${clientId}`);
}

export async function createClient({ data }: { data: CreateClientPayload }) {
  return await api.post('clients', { ...data });
}

export async function updateClient({ data: { id, ...payload } }: { data: UpdateClientPayload }) {
  return await api.put(`clients/${id}`, { ...payload });
}

export async function deleteClient({ clientId }: { clientId: number }) {
  return await api.delete(`clients/${clientId}`);
}

export async function getContacts(): Promise<Contact[]> {
  return await api.get('contacts');
}

export async function getContact({ contactId }: { contactId: number }): Promise<Contact> {
  return await api.get(`contacts/${contactId}`);
}

export async function createContact({ data }: { data: CreateContactPayload }) {
  return await api.post('contacts', { ...data });
}

export async function updateContact({ data: { id, ...payload } }: { data: UpdateContactPayload }) {
  return await api.put(`contacts/${id}`, { ...payload });
}

export async function deleteContact({ contactId }: { contactId: number }) {
  return await api.delete(`contacts/${contactId}`);
}

export async function getProjects(): Promise<Project[]> {
  return await api.get('projects');
}

export async function getProject({ projectId }: { projectId: number }): Promise<Project> {
  return await api.get(`projects/${projectId}`);
}

export async function createProject({ data }: { data: CreateProjectPayload }) {
  return await api.post('projects', { ...data });
}

export async function updateProject({ data: { id, ...payload } }: { data: UpdateProjectPayload }) {
  return await api.put(`projects/${id}`, { ...payload });
}

export async function deleteProject({ projectId }: { projectId: number }) {
  return await api.delete(`projects/${projectId}`);
}

export async function getStateLookups(): Promise<CodeBasedRef[]> {
  return await api.get('lookups/states');
}

export async function getClientStatusLookups(): Promise<CodeBasedRef[]> {
  return await api.get('lookups/client-statuses');
}
